import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterLink} from "@angular/router";
import {HttpClientModule} from "@angular/common/http";
import {MaterialModule} from "../material/material.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { LoginComponent } from './login/login.component';
import { AccountLeftBannerComponent } from "../pages/account/shared/account-left-banner/account-left-banner.component";
import { AnonymouHeaderComponent } from '../shared/anonymou-header/anonymou-header.component';
import { ToasterContainerComponent } from '../shared/toaster/toaster-container.component';
import { ToasterComponent } from '../shared/toaster/toaster.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { AppPasswordStrengthComponent } from './app-password-strength/app-password-strength.component';
import { NotificationComponent } from '../shared/notification/notification.component';
import { CodeConfirmationComponent } from './code-confirmation/code-confirmation.component';
import { CodeInputModule } from 'angular-code-input';
import { CreateNewPasswordComponent } from './create-new-password/create-new-password.component';



@NgModule({
    declarations: [
        LoginComponent,
        ToasterContainerComponent,
         ToasterComponent,
         SetPasswordComponent,
         AppPasswordStrengthComponent,
         CodeConfirmationComponent,
         CreateNewPasswordComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        RouterLink,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        AccountLeftBannerComponent,
        NotificationComponent,
        CodeInputModule
    ],
    exports:[
        AppPasswordStrengthComponent
    ]
})
export class SecurityModule { }
